import React, {useState} from 'react'
import AppLayout from '@/Layouts/AppLayout'
import OrganizationLayout from '@/Layouts/OrganizationLayout'
import {Container, Subheader} from "@/Components";
import {OnboardingSteps} from "@/Pages/Organization/Onboarding/Partials/Steps";
import {ToggleSwitch} from "@/Components/Form";
import {InertiaLink} from "@inertiajs/inertia-react";
import {Inertia} from "@inertiajs/inertia";

export default function OnboardingActivities({
   errors,
   managed_activities
 }) {

  const [idList, setIdList] = useState(new Set());
  const [activities, setActivities] = useState(managed_activities?.data);

  const BASE_TAGS = ['Transport', 'Product usage', 'Energy'];

  const deactivateActivity = (id, index) => {

    // Update the state
    const activity = activities[index];
    activity.deactivated = ! activity.deactivated;

    setActivities( prevValues => {
      return { ...prevValues, [index]: activity}
    });

    // Create idList of deselected items
    const tmpList = new Set(idList)
    if (!tmpList.has(id)) {
      tmpList.add(id)
    } else {
      tmpList.delete(id)
    }
    setIdList(tmpList)
  }

  const handleSave = () => {
      if(idList.size > 0) {
          // Passing empty ID should be allowed, but we're only redirected to login? Pass ID 0 (parsed as false value) to hack the system and allow access
          Inertia.post(`/emission-accounting/activity/deactivate/0`, {status: true, activities: Array.from(idList)}, {
              preserveScroll: true,
              onSuccess: () => {
                  Inertia.visit('/onboarding/reporters');
              },
          });
      } else {
          Inertia.visit('/onboarding/reporters');
      }
  }

  return <>
    <OnboardingSteps currentStep={1} steps={['Reporting', 'Activities', 'Reporters']}/>

    <h4 className="text-xl mb-4 font-bold">Choose activities to report on</h4>

    <Container padding="" className="md:dots-orange md:dots-orange--no-top-overflow relative z-10">
      {BASE_TAGS.map((tag) => <>

        <Subheader margin="mb-4 mt-8">{tag}</Subheader>

        {managed_activities?.data?.map((activity, index) => activity.tag === tag ?
            <div key={activity.id} className={`relative mb-2 border border-gray-200 p-4 flex justify-between ${activity.deactivated ? 'bg-gray-lighter' : 'bg-white '}`}>
              <div className="flex space-x-2">
                <p>{activity.name}</p>
                <p className="text-slate">CO₂ per {activity.factor.unit}</p>
              </div>
              <ToggleSwitch checked={!activity.deactivated} onChange={() => deactivateActivity(activity.id, index)}></ToggleSwitch>
            </div>
          : null
        )}
      </>)}


      <div className="flex justify-end w-full mt-4 mb-16">
        <InertiaLink className="text-blue underline py-4 cursor-pointer" href="/onboarding/reporters">
          Skip
        </InertiaLink>
        <button
          onClick={handleSave}
          className="self-end ml-3 btn"
        >
          Save changes
        </button>
      </div>
    </Container>
  </>
}

OnboardingActivities.layout = page => (
  <AppLayout title="Onboarding - Activities">
    <OrganizationLayout header="">
      {page}
    </OrganizationLayout>
  </AppLayout>
)
